import { Users } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '~/shared/shadcn/ui/dialog';
import { VolunteerManagementTable } from '~entities/recital-manager/ui/VolunteerManagementTable';
import { useGetAllShows } from '~entities/recital-manager/api/get-all-shows';

interface RecitalVolunteersDialogProps {
  recitalId: string;
  recitalName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RecitalVolunteersDialog({
  recitalId,
  recitalName,
  open,
  onOpenChange,
}: RecitalVolunteersDialogProps) {
  // Fetch shows for the recital
  const { data: showsData } = useGetAllShows({
    recitalId,
    limit: 100, // Get all shows
  });

  const shows = showsData?.data ?? [];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            Volunteer Management - {recitalName}
          </DialogTitle>
          <DialogDescription>
            Manage volunteers for this recital. You can add, edit, and remove volunteers.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          {/* Volunteer Management Table */}
          <VolunteerManagementTable recitalId={recitalId} shows={shows} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
